module.exports = __webpack_public_path__ + "static/media/expo-2-1.9fc2f5d4.png";